// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2DW6l","left":"styles_left__3QNvI","desktopActions":"styles_desktopActions__2ZmJn","title":"styles_title__1dHxm"};